/* Lettoria NEVERMORE SALE page — cart module for the Horizon theme. Clone of afroyla-dd-horizon-cart.js (DD frozen).
 * ES MODULE (<script type="module">): Shopify's asset minifier rewrites dynamic import() in classic scripts to require().
 * Exposes window.LNMCart.add({ items }) → Promise<cart>. Dispatches CartLinesUpdateEvent BEFORE the fetch so
 * cart-drawer-component auto-opens and cart-icon / cart-items update exactly like a PDP add.
 * Flow = Horizon product-form: POST /cart/add.js (+ `sections`) → GET /cart.js → resolve the event with that cart.
 * The GET is REQUIRED: createCartFromAjaxResponse needs a full cart (currency etc.) — add.js alone throws
 * "Currency code is required" (Afroyla 2026-09-25). Nevermore/Evermore products are Simple Bundles → server add ~1–2 s. */
import { CartLinesUpdateEvent } from '@shopify/events';

function getCart() {
  return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then((r) => r.json());
}

async function add({ items }) {
  const source = document.querySelector('[data-lnm]') || document.body;
  const itemCount = items.reduce((s, it) => s + it.quantity, 0);
  const ids = [...document.querySelectorAll('cart-items-component')].map((el) => el.dataset.sectionId).filter(Boolean);
  const body = { items };
  if (ids.length) body.sections = ids.join(',');

  const deferred = CartLinesUpdateEvent.createPromise();
  source.dispatchEvent(new CartLinesUpdateEvent({
    action: 'add', context: 'product', promise: deferred.promise,
    lines: items.map((it) => ({ merchandiseId: String(it.id), quantity: it.quantity })),
  }));

  try {
    const r = await fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
    const res = await r.json();
    if (!r.ok || res.status) throw new Error(res.description || res.message || `cart/add ${r.status}`);
    const cart = await getCart();
    deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { items: cart.items, sections: res.sections || null, itemCount, source: 'lettoria-nevermore-sale', didError: false } });
    return cart;
  } catch (e) {
    // settle the theme's listeners (drawer / icon) with the real cart, then surface the error to the button
    getCart()
      .then((cart) => deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { items: cart.items, itemCount: 0, source: 'lettoria-nevermore-sale', didError: true } }))
      .catch(() => deferred.reject(e));
    throw e;
  }
}

window.LNMCart = { add };
